export const NF_TRT_DEFAULT_VALUE = ({ user, customer }) => {
  void customer;
  return {
    patient: {
      male: true
    },
    provider: {
      name: `${user.firstName} ${user.lastName} NP`,
      clinicName: `Jack Jill Health`,
      address: 'Unit 400-2620 Bristol Circle',
      city: 'Oakville',
      province: 'ON',
      postalCode: 'L6H 6Z7',
      phone: '289-401-4678',
      fax: '855-952-2436'
    },
    diagnosis: {
      diagnosis: 'Low Testosterone'
    },
    hematology: {
      cbc: true
    },
    chemistry: {
      glufa: true,
      hba1cthb: true,
      cr: true,
      alt: true,
      lipidp: true,
      tsh: true,
      crphs: true,
      ferri: true,
      psa: true,
      album: true
    },
    additionalRequests: {
      requests:
        'Estradiol, Testosterone (Free and total), Alk Phosphate, Prolactin, LH, FSH, B12, Total Insulin'
    }
  };
};

export const NF_LGV_DEFAULT_VALUE = ({ user, customer, organization }) => {
  const jackLgvAdditionalRequests =
    'Magnesium (Serum), Lipoprotein(a), AST, Cortisol (random), Lipase, Free T3/Free T4, Serum iron (Fe), TIBC, % transferrin saturation, GGT (Gamma-glutamyl transferase), Calcium, Serum Phosphate (PO4), Nucleated RBC (NRBC)';
  const jillLgvAdditionalRequests =
    'Progesterone, DHEA-S, Lipase, Free T3/Free T4, Serum iron (Fe), TIBC, % transferrin saturation, Uric Acid, Magnesium (Serum), AST, GGT (Gamma-glutamyl transferase), Lipoprotein(a), Cortisol (random), Calcium, Serum Phosphate (PO4), Nucleated RBC (NRBC), Apolipoprotein B (ApoB)';
  const jackBase = NF_TRT_DEFAULT_VALUE({ user, customer });
  const jillBase = NF_TRT_DEFAULT_VALUE({ user, customer });
  const baseRequestsWithoutCrp = (requests: string) =>
    requests
      .replace(', CRP, Total Insulin', ', Total Insulin')
      .replace('CRP, ', '')
      .replace('CRP', '');
  const defaultsByProfile = {
    jack_health: {
      ...jackBase,
      diagnosis: {
        diagnosis: 'Preventative Evaluation'
      },
      chemistry: {
        ...jackBase.chemistry,
        sodiu: true,
        potas: true,
        urate: true,
        crphs: true,
        psa: false
      },
      additionalRequests: {
        requests: `${baseRequestsWithoutCrp(
          jackBase.additionalRequests.requests
        )}, ${jackLgvAdditionalRequests}`
      }
    },
    // NF has no WL baseline yet, so Jill currently mirrors TRT until customized.
    jill_health: {
      ...jillBase,
      diagnosis: {
        diagnosis: 'Preventative Evaluation'
      },
      chemistry: {
        ...jillBase.chemistry,
        sodiu: true,
        potas: true,
        crphs: true,
        psa: false
      },
      additionalRequests: {
        requests: `${baseRequestsWithoutCrp(
          jillBase.additionalRequests.requests.replace(
            'Testosterone (Free and total)',
            'Testosterone (Total)'
          )
        )}, ${jillLgvAdditionalRequests}`
      }
    }
  };
  const normalizedGender = customer?.gender?.toLowerCase?.();
  if (normalizedGender === 'male' || normalizedGender === 'm') {
    return defaultsByProfile.jack_health;
  }
  if (normalizedGender === 'female' || normalizedGender === 'f') {
    return defaultsByProfile.jill_health;
  }
  return defaultsByProfile[organization] || defaultsByProfile.jack_health;
};
